module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#sort",
      toString: function () {
        return this.url;
      }
    }